import React from 'react';

export const Title = React.memo(({ text }) => <h1>{text}</h1>);
